export default __webpack_public_path__ + "static/media/MaskGroup329.0a623667.png";